import { render, staticRenderFns } from "./meetingManagement.vue?vue&type=template&id=3bd8af0b&scoped=true"
import script from "./meetingManagement.vue?vue&type=script&lang=js"
export * from "./meetingManagement.vue?vue&type=script&lang=js"
import style0 from "./meetingManagement.vue?vue&type=style&index=0&id=3bd8af0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8af0b",
  null
  
)

export default component.exports